import LegalDoc from "./LegalDoc";

export default function CondizioniConsegna() {
  return (
    <LegalDoc
      field="legal_delivery"
      overline="Spedizione"
      title={<>Condizioni di <span className="italic text-[#D47738]">consegna</span></>}
      related={[
        { to: "/condizioni-acquisto", label: "Condizioni di acquisto" },
        { to: "/politica-rimborso", label: "Politica di rimborso" },
      ]}
    />
  );
}
